import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  container: {
    marginTop: "34px",
    marginLeft: "28px",
    marginRight: "28px",
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  },
  leftContainer: {
    height: "80vh",
    width: "100%",
    overflow: "scroll",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      height: "70vh",
      width: "100%",
      order: 2,
    },
  },
  bottomContainer: {
    width: "100%",
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
      order: 1,
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(0),
    },
  },
  buttonContainer: {
    width: "100%",
    height: "5%",
    display: "flex",
    paddingRight: "3%",
    padding: "1%",
    marginBottom: "2%",
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: "1%",
      order: 1,
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2),
      paddingRight: "3%",
    },
  },
  searchBox: {
    width: "100%",
    height: "3%",
    display: "flex",
    padding: "2%",
    marginBottom: "5px",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  search: {
    flex: 10,
    background: "#f8f9fc",
    borderRadius: "4px",
    marginLeft: "2px",
    maxWidth: "200px",
    [theme.breakpoints.down("sm")]: {
      width: 200,
    },
    [theme.breakpoints.down("xs")]: {
      width: 150,
    },
  },
}))

export default styles
